import React, { useCallback, useState } from 'react';
import { toast } from 'react-hot-toast';

import { Form } from '@unform/web';

import { FaCopy, FaPlus } from 'react-icons/fa';
import { FiTrash } from 'react-icons/fi';

import formatValue from '../../../utils/formatValue';

import {
  ProductName,
  ProductImage,
  NoImage,
  MenuItemPromotion,
  NumberFormatStyled,
  SubmitStyledButton,
} from '../styles';

import Input from '~/components/Form/Input';

import api from '~/services/api';

function currencyFormatter(value) {
  if (!Number(value)) return 'R$ 0,00';

  const amount = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value / 100);

  return `${amount}`;
}

function Item({
  type,
  item,
  n99FoodRestaurants,
}) {
  const [ifoodItems, setIfoodItems] = useState(
    (type === 'complement' ? item.ifood_complements : item.ifood_products) || []
  );

  const handleSave = useCallback(
    async (data) => {
      const ifood_restaurant_id = parseInt(data.ifood_restaurant_id);

      try {
        const body = {
          pdv_code: data.pdv_code,
          ifood_restaurant_id,
        };

        if (type === 'complement') {
          body.complement_id = item.id;
        } else {
          body.product_id = item.id;
        }

        const url = type === 'complement'
          ? '/restaurants/99food/complements'
          : '/restaurants/99food/products';

        const response = await api.post(url, body);

        const newIfoodItems = [
          ...ifoodItems,
          response.data
        ];

        setIfoodItems(newIfoodItems);

        toast.success('Item associado com sucesso!');
      } catch (error) {
        console.log(error);
        toast.error('Erro ao vincular');
      }
    },
    [item, ifoodItems]
  );

  return (
    <tr>
      <td style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          {item.image && (item.image.url_thumb || item.image.url) ? (
            <ProductImage
              src={item.image.url_thumb || item.image.url}
              alt="Foto do produto"
            />
          ) : (
            <NoImage />
          )}
        </div>
        <div style={{ marginLeft: '6px' }}>
          <ProductName>{item.name}</ProductName>
        </div>
      </td>
      <td style={{ paddingRight: '20px' }}>
        {item.price_promotion ? (
          <>
            <MenuItemPromotion>
              {formatValue(item.price)}
            </MenuItemPromotion>

            <NumberFormatStyled
              prefix="R$"
              format={currencyFormatter}
              name="value"
              defaultValue={formatValue(item.price_promotion)}
              disabled
            />
          </>
        ) : (
          <NumberFormatStyled
            prefix="R$"
            format={currencyFormatter}
            name="value"
            defaultValue={formatValue(item.price)}
            disabled
          />
        )}
      </td>

      <td style={{ width: '450px' }}>
        {n99FoodRestaurants.map((restaurant, ridx) => (
          <Form onSubmit={handleSave} key={`ridx-${ridx}`}>
            <div style={{ display: 'flex' }}>
              <div style={{ width: '100%', marginRight: 10 }}>
                 <div style={{marginTop: 10, marginBottom: 10}}>
                  <Input
                    name="pdv_code"
                    label={`Código PDV${n99FoodRestaurants.length > 1 ? ` (${restaurant.name})` : ''}`}
                  />
                 </div>
              </div>

              <Input
                style={{ display: 'none' }}
                value={restaurant.ifood_restaurant_id}
                name="ifood_restaurant_id"
              />
              <div>
                <SubmitStyledButton
                  id="limit"
                  type="submit"
                  style={{
                    marginLeft: 'auto',
                    marginTop: 35,
                  }}
                >
                  <FaPlus />
                </SubmitStyledButton>
              </div>
            </div>

            {ifoodItems
               .filter(
                 (item) => item.ifood_restaurant_id === restaurant.ifood_restaurant_id
               )
               .map((item) => (
                 <div style={{
                   display: 'flex',
                   justifyContent: 'space-between',
                   width: '100%',
                 }}>
                   <div style={{width: '100%', marginRight: 10}}>
                     <Input 
                       disabled
                       name="display_pdv"
                       value={item.ifood_id}
                       style={{ color: '#3D3D3D'}}
                     /> 
                   </div>

                   <SubmitStyledButton
                     type="button"
                     style={{
                       marginRight: '5px',
                     }}
                     onClick={() => {
                       console.log('@@ sending');
                       navigator.clipboard.writeText(item.ifood_id);
                       toast.success('Código copiado com sucesso.')
                     }}
                   >
                     <FaCopy />
                   </SubmitStyledButton>

                   <SubmitStyledButton
                     id="limit"
                     type="button"
                     style={{ background: '#ff2c3a' }}
                     onClick={(e) => {
                       // handleDeleteIfood({
                       //   ifood_id: prod.ifood_id,
                       //   ifood_restaurant_id:
                       //   restaurant.ifood_restaurant_id,
                       // });
                     }}
                   >
                     <FiTrash />
                   </SubmitStyledButton>
                 </div>
               ))}
          </Form>
        ))}
      </td>
    </tr>
  );
}

export default Item;
